class CompareAndUpdateCandidateDetailsModalController {
    constructor() {
        // this.candidateConflictDetails = this.resolve.candidateConflictDetails;
    }
    $onInit() {
        this.candidateConflictDetails = this.resolve.candidateConflictDetails;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    }
    saveCallback(contactDetails) {
        this.callbackObject = { callbackType: 'save', entity: contactDetails };
        this.closeModal();
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
}
// import * as TEMPLATE from './compare-and-update-candidate-details-modal.html';
import * as TEMPLATE from 'raw-loader!./compare-and-update-candidate-details-modal.html';
export const CompareAndUpdateCandidateDetailsModalComponent = {
    selector: 'compareAndUpdateCandidateDetailsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: CompareAndUpdateCandidateDetailsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/addCandidates/addCandidates/uploadResumes/compareAndUpdateCandidateDetailsModal/compare-and-update-candidate-details-modal.html'
    }
};
//# sourceMappingURL=compare-and-update-candidate-details-modal.component.js.map